import { Component, OnInit } from '@angular/core';
import { API_ServerAddress } from '../../../MyAppCommonConfig';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { CAward } from 'src/app/models/award.models/award.model';
import { AwardService } from 'src/app/services/award.service';
import { themservice } from '../../../services/them.service';
@Component({
    selector: 'awardDetails',
    templateUrl: 'awardDetails.component.html'
})
export class AwardDetailsComponent implements OnInit {
    ngOnInit(): void {
        this.GetAward();
    }

    ApiServiceAddress: string;
    award: CAward = new CAward();
    id: number;

    constructor(private awardService: AwardService,public themservice: themservice, private route: ActivatedRoute, private location: Location, private titleService: Title, private metaService: Meta) {
        this.ApiServiceAddress = API_ServerAddress;
        this.id = +this.route.snapshot.paramMap.get('id');
        //this.sharedValueService.switchToCompany();
    }

    GetAward() {
        this.awardService.GetById(this.id)
            .subscribe((data: CAward) => {
                this.award = data;
                this.SetPageMetaData(data);
            });
    }

    goBack(): void {
        this.location.back();
    }

    SetPageMetaData(model: CAward) {
        this.titleService.setTitle(model.fSubject);
        this.metaService.updateTag({ name: 'description', content: model.fMetaDescription });
        this.metaService.updateTag({ name: 'keywords', content: model.fMetaKeywords });
    }
}